import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import AuthLayout from "./AuthLayout";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <AuthLayout title="Choose a new password" subtitle="Use at least 8 characters.">
      <form onSubmit={submit} className="space-y-5">
        <div><Label htmlFor="pw">New password</Label><Input id="pw" type="password" minLength={8} required className="mt-1.5 h-11" data-testid="reset-password-input" value={password} onChange={(e) => setPassword(e.target.value)} /></div>
        {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
        <Button type="submit" className="w-full h-11" data-testid="reset-submit-button">Update password</Button>
        <p className="text-sm text-center"><Link to="/login" className="text-primary hover:underline">Back to sign in</Link></p>
      </form>
    </AuthLayout>
  );
}
